import { render } from "./treeView.vue?vue&type=template&id=be2f39ec"
import script from "./treeView.vue?vue&type=script&lang=js"
export * from "./treeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__